import { Button } from 'antd';

import { ChatbotIcon } from '../../assets';
import InlineStyled from '../../CommonComponents/InlineStyled/InlineStyled';

const BotInitialChat = ({ text = '', buttons = [], onButtonClick, text2 }) => {
  return (
    <InlineStyled $style={{ marginTop: 20 }} className='chatbot-msg'>
      <InlineStyled $style={{ display: 'flex', gap: 16, paddingRight: 35 }} className='msg-inner'>
        <InlineStyled
          $style={{ width: 35, height: 36, flexShrink: 0 }}
          as='span'
          className='chatbot-msg-img'
        >
          <ChatbotIcon />
        </InlineStyled>
        <InlineStyled
          $style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 5 }}
          className='response-msg'
        >
          {text}
          <InlineStyled
            $style={{ display: 'flex', flexFlow: 'row wrap', gap: 12, alignItems: 'center' }}
          >
            {buttons.map((v) => (
              <InlineStyled
                key={v.id}
                as={Button}
                $style={{
                  height: 'auto',
                  padding: '8px 15px',
                  textWrap: 'wrap',
                  textAlign: 'left',
                }}
                onClick={() => {
                  v.onClick?.(v);
                  onButtonClick(v);
                }}
                disabled={v.disabled}
                icon={v.icon}
                iconPosition='end'
              >
                {v.label}
              </InlineStyled>
            ))}
            {text2}
          </InlineStyled>
        </InlineStyled>
      </InlineStyled>
    </InlineStyled>
  );
};

export default BotInitialChat;
